import API from 'services/api';

interface IReportInvalidCardResponse {
  success: boolean;
  message: string;
}

export const reportInvalidCard = ({
  calculationId,
}: {
  calculationId: string;
}): Promise<IReportInvalidCardResponse> =>
  API.post(
    `/api/accommodation/calculations/${calculationId}/booking/report-invalid-credit-card`,
    {},
  ).then(response => response?.data);
